import * as React from 'react';
import './index.css';
import TrackUtils from '../../utils/TrackUtils';

interface IProps {
  defaultCount: number | undefined;
  changeCount: Function;
  lab: object; //埋点用
  count: number;
}
export default class Count extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  shouldComponentUpdate(nextProps: Readonly<IProps>, nextContext: any): boolean {
    return nextProps.count !== this.props.count;
  }

  render() {
    const { count } = this.props;
    const { defaultCount } = this.props;
    let desImg = '';
    switch (true) {
      case count === 1 && defaultCount === undefined:
        desImg = 'assets://shop/icon_multi_sku_dec_unable.png';
        break;
      case count === 0 && defaultCount !== undefined:
        desImg = 'assets://shop/icon_multi_sku_dec_unable.png';
        break;
      default:
        desImg = 'assets://shop/icon_multi_sku_dec.png';
        break;
    }
    return (
      <view className="container">
        <image className="icon" src={desImg} onClick={this.desFood} />
        <text
          className="add-btn-text"
          style={{ minWidth: Mach.env.isIOS ? 16 : 0 }}
          content={`${this.props.count}`}
        />
        <image className="icon" src="assets://shop/icon_multi_sku_add.png" onClick={this.addFood} />
      </view>
    );
  }

  private desFood = () => {
    const { count } = this.props;
    const {
      lab, changeCount, defaultCount,
    } = this.props;
    TrackUtils.countMC(count, lab, 1);
    if (count > 1 || (count === 1 && defaultCount)) {
      changeCount(count, 0);
    }
  }

  private addFood = () => {
    const { count } = this.props;
    const { lab, changeCount } = this.props;
    TrackUtils.countMC(count, lab, 0);
    if (count >= 0) {
      changeCount(count, 1);
    }
  }
}
